module.exports = __webpack_public_path__ + "static/media/SinteringFurnace.a439e6b6.png";